

























































































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import Campaign from "@/store/entities/campaign";
import Ajax from '@/lib/ajax'
import GiftPackage from "@/store/entities/gift-package";

import CreateStockVM from "@/views/lottery/stock/create.vue";
import UpdateStockVM from "@/views/lottery/stock/edit.vue";
import {AddStockDto, CreateParamsDto, GiftInfoConfig, StockTableDto} from "@/store/entities/gift-info-config";
import url from "@/lib/url";


@Component({
  components: {CreateStockVM, UpdateStockVM}
})
export default class StockVM extends AbpBase {
  loadOptioning: boolean = false;
  stockList: GiftInfoConfig[] = new Array<GiftInfoConfig>();
  packageList: GiftPackage[] = new Array<GiftPackage>();
  campaignList: Campaign[] = new Array<Campaign>();
  campaignId: number = 0;
  packageId: number = 0;
  loading: boolean = false;
  params: CreateParamsDto = new CreateParamsDto();
  createModalShow: boolean = false;
  editModalShow: boolean = false;

  configInfo: StockTableDto[] = [];

  editModel: any = {};


  download() {
    console.log(this.campaignId)
    if (!this.campaignId) {
      this.notice('请选择活动')
      return;
    }
    let path = `${url}api/services/app/GiftInfoConfig/DownLoadStockInfo?campaignId=${this.campaignId}&packageId=${this.packageId}`
    location.href = path;
  }

  async confirmFileConfig(filePath: string) {

    if (!this.campaignId) {
      this.notice('请选择活动')
      return;
    }
    this.loading = true;
    let response = await Ajax.post('/api/services/app/GiftInfoConfig/UploadStockInfo',
        {campaignId: this.campaignId, originExcelUrl: filePath});
    console.log(response)

    this.notice(response.data.result.msg);

    this.loading = false;
    await this.getpage();
  }


  get uploadURL() {

    return `${url}api/services/app/GiftInfoConfig/ImportData?campaignId=${this.campaignId}`;

  }

  get token() {
    return "Bearer " + window.abp.auth.getToken();
  }

  async onSuccess(response, file, fileList) {

    if (response.result) {
      console.log(response.result);
      this.$Modal.confirm({
        title: this.L('Tips'),
        content: this.L('确定要用这个文件批量配置？'),
        okText: this.L('Yes'),
        cancelText: this.L('No'),
        onOk: async () => {
          await this.confirmFileConfig(response.result)

        }
      })
    } else {
      this.$Message.error("上传失败");
    }
  }

  async onError(response, file, fileList) {
    this.$Message.error("导入失败");
  }


  change(cid) {
    console.log(cid)
    this.campaignId = cid;
    let m = this.campaignList.find(x => x.id == cid);
    console.log(m)
    this.$store.commit('main/setCampaign', m)
    this.getPackage(cid);
  }

  async getCampaign() {
    this.packageId = 0;
    this.loadOptioning = true;

    let response = await Ajax.get('/api/services/app/Campaign/GetAll', {params: {maxResultCount: 1000, dataState: 1}});
    this.campaignList = response.data.result.items as Array<Campaign>;
    this.loadOptioning = false;
  }

  async getPackage(campaignId) {
    this.loadOptioning = true;
    this.packageId = 0;
    let response = await Ajax.get('/api/services/app/GiftPackage/GetAll', {
      params: {
        maxResultCount: 1000,
        dataState: 1,
        campaignId: campaignId
      }
    });
    this.packageList = response.data.result.items as Array<GiftPackage>;
    this.loadOptioning = false;
  }

  create(group: string) {

    if (!this.packageId) {
      this.notice('请选择礼包');
    }
    console.log(group);
    this.params = new CreateParamsDto();
    this.params.packageId = this.packageId;
    this.params.campaignId = this.campaignId;
    if (group) {
      let p = group.split('至');
      this.params.startTime = p[0];
      this.params.endTime = p[1];
    }

    this.createModalShow = true;

  }

  edit(editModel) {
    this.editModel = editModel;
    console.log(this.editModel)
    this.editModalShow = true;
  }

  async getpage() {

    if (!this.packageId) {
      this.notice('请选择礼包');

    }
    this.loading = true;
    let response = await Ajax.get('/api/services/app/GiftInfoConfig/GetAllStock', {params: {packageId: this.packageId}});

    console.log(response.data.result)

    this.configInfo = response.data.result;

    this.loading = false;
  }

  async deleteConfig(id) {
    let response = await Ajax.delete('/api/services/app/GiftInfoConfig/Delete?id=' + id);
  }

  async changeOrder(row, index, type) {
    let aid, bid = 0;
    let model = this.configInfo.find(x => x.key === row.group);
    if (type === 'up') {
      if (index == 0) {
        this.notice('已经在最上面了！')
        return;
      }
      aid = row.id;
      bid = model.value[index - 1].id;
    } else if (type === 'down') {
      if (index == model.value.length - 1) {
        this.notice('已经在最下面了！')
        return;
      }
      aid = row.id;
      bid = model.value[index + 1].id;
    }
    if (aid === 0 || bid === 0) {
      return;
    }
    await Ajax.post('/api/services/app/GiftInfoConfig/ChangeSort', {aid: aid, bid: bid});
    await this.getpage();
  }

  columns = [

    {
      title: this.L('奖品名称'),
      key: 'giftName'
    },
    {
      title: this.L('奖品代码'),
      key: 'giftCode'
    },
    {
      title: this.L('总库存'),
      key: 'totalInventory'
    },
    {
      title: this.L('剩余库存'),
      key: 'currentInventory'
    },
    // {
    //   title: this.L('共享库存'),
    //   render: (h: any, params: any) => {
    //     return h('span', params.row.commonStockId > 0 ? this.L('是') : this.L('否'))
    //   }
    // },
    {
      title: this.L('概率'),
      key: 'probability'
    },
    {
      title: this.L('备注'),
      key: 'remark'
    }
    , {
      title: this.L('Actions'),
      key: 'Actions',
      width: 150,
      render: (h: any, params: any) => {
        return h('div', [
          h('Button', {
            props: {
              type: 'primary',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {
                this.edit(params.row)
              }
            }
          }, this.L('Edit')),
          h('Button', {
            props: {
              type: 'error',
              size: 'small'
            },
            on: {
              click: async () => {
                this.$Modal.confirm({
                  title: this.L('Tips'),
                  content: this.L('删除这个库存配置？'),
                  okText: this.L('Yes'),
                  cancelText: this.L('No'),
                  onOk: async () => {
                    await this.deleteConfig(params.row.id);
                    await this.getpage();
                  }
                })
              }
            }
          }, this.L('Delete'))
        ])
      }
    }
    , {
      title: this.L('顺序'),
      key: '顺序',
      width: 150,
      render: (h: any, params: any) => {
        return h('div', [
          h('Button', {
            props: {
              type: 'success',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
            on: {
              click: () => {

                this.changeOrder(params.row, params.index, 'up');
              }
            }
          }, '上移'),
          h('Button', {
            props: {
              type: 'warning',
              size: 'small'
            },
            on: {
              click: () => {
                this.changeOrder(params.row, params.index, 'down')
              }
            }
          }, '下移')
        ])
      }
    }
  ]


  async created() {
    await this.getCampaign();
    let m = this.$store.state.main.campaign as Campaign;
    if (m) {
      this.campaignId = m.id;
      await this.getPackage(m.id);
    }
  }

  notice(msg) {
    this.$Notice.info({
      title: '提示',
      desc: msg
    });
  }

}
